import { useState, useCallback } from 'react';
import type { ScheduledProcedureCodeType } from '../../../../../../services/EncounterService/types/encounterTypes';

/**
 * Hook for managing scheduled procedure code edit dialog state
 */
export function useScheduledProcedureCodeEditDialog(
  sortedCodes: ScheduledProcedureCodeType[],
  isEncounterCancelled: boolean
) {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedCodeId, setSelectedCodeId] = useState<string | null>(null);

  // Get the current code from the sorted list
  const selectedCode = selectedCodeId
    ? sortedCodes.find((code) => code.id === selectedCodeId) || null
    : null;

  const handleEdit = useCallback((id: string) => {
    setSelectedCodeId(id);
    setEditDialogOpen(true);
  }, []);

  const handleRowSelection = useCallback(
    (args: any) => {
      // Don't allow editing if encounter is cancelled
      if (isEncounterCancelled) {
        return;
      }

      if (args.data) {
        const code = sortedCodes.find((c) => c.id === args.data.id);
        if (code) {
          setSelectedCodeId(code.id!);
          setEditDialogOpen(true);
        }
      }
    },
    [sortedCodes, isEncounterCancelled]
  );

  const handleClose = useCallback(() => {
    setEditDialogOpen(false);
    setSelectedCodeId(null);
  }, []);

  return {
    editDialogOpen,
    selectedCode,
    handleEdit,
    handleRowSelection,
    handleClose,
  };
}
